import { theme } from 'lib/theme';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  buttonContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingHorizontal: theme.paddingHorizontal,
  },
  logo: {
    alignItems: 'center',
    marginBottom: theme.grid,
  },
  textFieldContainer: {
    marginBottom: theme.paddingHorizontal,
  },
  textFieldInput: {
    borderRadius: 4,
    textAlign: 'center',
  },
});
